import styles from "./styles.module.css";
import FormField from "../../FormField";
import { useIntl } from "react-intl";

const PersonalInfoForm = ({
  formDisabled,
  formData,
  handleChange,
  versionInfo,
  emailTypes,
  getValidationError,
}) => {
  const intl = useIntl();

  return (
    <div className={styles["personal-info-container"]}>
      <FormField
        value={formData.first_name}
        name="first_name"
        type="text"
        id="first_name"
        label={intl.formatMessage({
          id: "label.first-name",
          defaultMessage: "First Name",
        })}
        handleChange={handleChange}
        disabled={formDisabled?.first_name}
        rules={{
          required: true,
          hasSubmitted: formData?.hasSubmitted || false,
          message: versionInfo?.requiredValidationError,
        }}
      />
      <FormField
        value={formData.last_name}
        name="last_name"
        type="text"
        id="last_name"
        label={intl.formatMessage({
          id: "label.last-name",
          defaultMessage: "Last Name",
        })}
        handleChange={handleChange}
        disabled={formDisabled?.last_name}
        rules={{
          required: true,
          hasSubmitted: formData?.hasSubmitted || false,
          message: versionInfo?.requiredValidationError,
        }}
      />

      <FormField
        value={formData.email1}
        name="email1"
        type="text"
        id="email1"
        label={intl.formatMessage({
          id: "label.email1",
          defaultMessage: "Email 1",
        })}
        handleChange={handleChange}
        disabled={!formData?.email1 ? false : formDisabled?.email1}
        deepDisable={!formData?.email1}
        rules={{
          hasSubmitted: formData?.hasSubmitted || false,
          ...(getValidationError()?.email1 || {}),
        }}
      />
      <div className={styles["email-type-default-container"]}>
        <FormField
          formType="coco"
          value={formData.email_type1}
          name="email_type1"
          type="select"
          id="email_type1"
          label={intl.formatMessage({
            id: "label.email-type",
            defaultMessage: "Email Type",
          })}
          handleChange={handleChange}
          options={emailTypes}
          disabled={formDisabled?.email_type1}
          deepDisable={!formData?.email1}
          rules={{
            hasSubmitted: formData?.hasSubmitted || false,
            ...(getValidationError()?.email_type1 || {}),
          }}
          selectStyle={{ height: 40 }}
        />
        <FormField
          formType="coco"
          value={formData.default_email1}
          name="default_email1"
          type="radio"
          id="default_email1"
          label={intl.formatMessage({
            id: "coco.rc.radio-set-as-default",
            defaultMessage: "Set as default for consent information",
          })}
          handleChange={handleChange}
          disabled={formDisabled?.email_type1}
          deepDisable={!formData?.email1}
        />
      </div>

      <FormField
        formType="coco"
        value={formData.email2}
        name="email2"
        type="text"
        id="email2"
        label={intl.formatMessage({
          id: "label.email2",
          defaultMessage: "Email 2",
        })}
        handleChange={handleChange}
        disabled={!formData?.email2 ? false : formDisabled?.email2}
        deepDisable={!formData?.email2}
        rules={{
          hasSubmitted: formData?.hasSubmitted || false,
          ...(getValidationError()?.email2 || {}),
        }}
      />
      <div className={styles["email-type-default-container"]}>
        <FormField
          formType="coco"
          value={formData.email_type2}
          name="email_type2"
          type="select"
          id="email_type2"
          label={intl.formatMessage({
            id: "label.email-type",
            defaultMessage: "Email Type",
          })}
          handleChange={handleChange}
          options={emailTypes}
          disabled={formDisabled?.email_type2}
          deepDisable={!formData?.email2}
          rules={{
            hasSubmitted: formData?.hasSubmitted || false,
            ...(getValidationError()?.email_type2 || {}),
          }}
          selectStyle={{ height: 40 }}
        />
        <FormField
          formType="coco"
          value={formData.default_email2}
          name="default_email2"
          type="radio"
          id="default_email2"
          label={intl.formatMessage({
            id: "coco.rc.radio-set-as-default",
            defaultMessage: "Set as default for consent information",
          })}
          handleChange={handleChange}
          disabled={formDisabled?.email_type2}
          deepDisable={!formData?.email2}
        />
      </div>

      <FormField
        value={formData.mobile}
        name="mobile"
        type="text"
        id="mobile"
        label={intl.formatMessage({
          id: "label.mobile",
          defaultMessage: "Mobile",
        })}
        handleChange={handleChange}
        disabled={!formData?.mobile ? false : formDisabled?.mobile}
        deepDisable={!formData?.mobile}
      />
    </div>
  );
};

export default PersonalInfoForm;
